  <br>
  <div>
    <button *ngIf="!isRunningConfirmation" type='button' class="btn btn-default ms-2" (click)="requestConfirmation()">Request Confirmation</button>
    <div *ngIf="isRunningConfirmation" class="ms-3 mt-3 mb-3">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Starting consolidation...</span>
      </div>
      <label>Running Request Confirmation...</label>
    </div>
  </div>
<br>
<div class="card">
  <div class="card-header">List of datasets which are currently pending confirmation (not active, not archived, not validationfailed)</div>
  <div *ngIf="!isLoaded" class="spinner-border ms-3 mt-3 mb-3" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <div id="grid-container" class="card-body" *ngIf="isLoaded">
    <angular-slickgrid gridId="gridComfirmation"
                       [columnDefinitions]="columnDefinitions"
                       [gridOptions]="gridOptions"
                       [dataset]="dataset">
    </angular-slickgrid>
  </div>
</div>
